module.exports = __webpack_public_path__ + "static/img/eye_ani.8abc6b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/eye_ani.png
// module id = 4y8H
// module chunks = 1 3